var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationGarden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da0021;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.2,455.19H263.51V324.09H365.87A14.1,14.1,0,0,0,380,310a14.43,14.43,0,0,0-14.12-14.12H132.4A14.09,14.09,0,0,0,118.29,310a14.43,14.43,0,0,0,14.11,14.12H234.77v131.1H212.08A14.09,14.09,0,0,0,198,469.31a14.43,14.43,0,0,0,14.12,14.12h73.61a14.1,14.1,0,0,0,14.12-14.12C299.81,461.74,294.27,455.19,286.2,455.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.53,167.77H143c2-61,19.67-113,45.39-145.22C101.65,38.68,32.56,88.1,15.92,151.63c-1.51,5.05,1,9.08,2,10.59A13.16,13.16,0,0,0,28.53,167.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.27,167.77V273.66h28.24V167.77h64C324,77,285.7,17,249.39,17c-35.8,0-74.63,60-78.16,150.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.25,167.77a14.21,14.21,0,0,0,10.59-5,12.83,12.83,0,0,0,2.52-10.59c-17.15-64-86.23-113.46-173-129.59,25.72,31.76,42.86,84.21,45.39,145.22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.12,360.9H63.32a12.42,12.42,0,0,1-12.1-10.59L38.11,250a14,14,0,1,0-27.73,3.53L23.49,353.84a38,38,0,0,0,16.64,27.22v88.25a14.43,14.43,0,0,0,14.12,14.12,13.56,13.56,0,0,0,13.61-13.62V389.13h63v80.68a14.12,14.12,0,0,0,28.24,0V389.13A13.84,13.84,0,0,0,171.74,375,13.39,13.39,0,0,0,158.12,360.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.8,237.86A14.1,14.1,0,0,0,461.17,250L448.06,350.31A12.42,12.42,0,0,1,436,360.9h-95.3A14.42,14.42,0,0,0,326.54,375c0,7.57,5.55,13.11,12.6,14.12v80.68a14.12,14.12,0,0,0,28.24,0V389.13h63.54v80.68a14.12,14.12,0,0,0,28.24,0V381.06c8.57-6.55,15.12-16.13,16.64-27.22l13.11-100.35A14.1,14.1,0,0,0,476.8,237.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGarden);
export default __webpack_public_path__ + "static/media/location_garden.a24774d4.svg";
export { ForwardRef as ReactComponent };